import React from "react";
import MyOffers from "@components/V3/MyOffers/index.js";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const MyOffersPage = () => {

    return (
        <VersionedLayout>
            <MyOffers />
        </VersionedLayout>
    );
};

export default MyOffersPage;
